;(function (Wishlist, $) {

  var $wishlistButton = $('.wishlist-btn');
  var $wishlistTile = $('.wishlist-tile-container');
  var numProductTiles = 0;
  var wishlist = localStorage.getItem('user_wishlist') || [];
 var source = document.getElementById("WishlistProductItemScript") ? document.getElementById("WishlistProductItemScript").innerHTML : null;
  var SPR;
  var hideLoader = false;
  var didBind = false;
  
  
  
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }
  

  /*
   * Update button to show current state (gold for active)
   */   
  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   
  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('is-active');
    /* Remove */
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      $("[data-product-handle='"+productHandle+"']").hide("slow", function(){ $(this).remove(); });
      numProductTiles--;
      
      if(numProductTiles === 0 || $('.wishlist-btn').length === 0) {
       $('.wishlist-grid--empty-list').addClass('is_visible'); 
        $('.wishlist-grid--empty-list').show();
      }
    }
    /* Add */ 
    else {
      wishlist.push(productHandle);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    }
  };
  

  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('is-active');
      }
    });
  };

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   
  var displayOnlyWishlistItems = function () {
    
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
  };
  
  var loadWishlistItemsAjax = function() {
    for(var i = 0; i < wishlist.length; i++) {
      var productAjaxURL = "/products/" + wishlist[i] + ".js";
      $.ajax({
        type: 'GET',
        dataType: 'json',
        url: productAjaxURL,
        success: function (data) {
          var template = Handlebars.compile(source);
          var showSticker = false;
          var soldOut = false;
          var onSale = false;
          var addFunc = "Shopify.addItem(" + data.variants[0].id + ", 1)";
          var hasCountdown = data.description.indexOf("[countdown]") > -1 ? true : false;
          var showProductType = false;
          var showProductReview = false;
          var showShortDescription = data.description.indexOf("[short_description]") > -1 ? true : false;
          var showWishlist = false; 
          var isExistingCustomer = false;
          var isSubscription = false;
          
          if (data.available === false) {
            var soldOut = true;
          };
          if (data.compare_at_price > data.price) {
            var onSale = true;
          };showSticker = true;showProductReview = true;
          
          
          
          var isSubscription = data.tags.length > 0 ? data.tags.some(function(t){ return t.toLowerCase().includes('subscription')}) : false;
          var descExcerpt = '';
          
          if(showShortDescription) {
            descExcerpt = data.description.slice(data.description.indexOf('[short_description]'), data.description.indexOf('[short_description]'));
          } else {
            descExcerpt = data.description.replace(/(<([^>]+)>)/ig,"").slice(0,80) + '...';
          }
          
           var context = {
             id: data.id,
            title: data.title,
            url: data.url,
            image: Shopify.resizeImage(data.featured_image, 'x500'),
            compare_price: Shopify.formatMoney(data.compare_at_price),
            price: Shopify.formatMoney(data.price),
            firstSKU: data.variants[0].sku,
            productAvailable: data.available,
             type: data.type,
             variants: data.variants,
             firstVariant: data.variants[0],
             handle: data.handle,
             shortDescription: descExcerpt,
            soldOut: soldOut,
            onSale: onSale,
             addFunc: addFunc,
             hasCountdown: hasCountdown,
             showProductType: showProductType,
             showProductReview: showProductReview,
             showShortDescription:showShortDescription,
             showWishlist: showWishlist,
             isExistingCustomer: isExistingCustomer,
             isASubscriptionProduct: isSubscription
          };
          
          var html = template(context);
          $(html).appendTo(".wishlist-grid");
          
          numProductTiles++;
          hideLoader = true;
          
           $('.wishlist-loader').fadeOut(500, function () {
              $('.wishlist-grid').addClass('is_visible');
              $('.wishlist-hero').addClass('is_visible');

                $('.wishlist-grid--empty-list').hide();
            });
                 
        },
        error: function (data, error) {
          //console.dir(data);
        }
      });
    }
  }
  
  var bindUIActions = function () {
    
    if(didBind === false) {
      $wishlistButton.click(function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
    
    didBind = true;
    }
    
  };

  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
  var loadWishlist = function () {
    
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      $('.wishlist-loader').show();
//       displayOnlyWishlistItems();
      if(wishlist.length > 0) {
         loadWishlistItemsAjax();
        $( document ).ajaxStop(function() {
        $wishlistButton = $('.wishlist-btn');
        bindUIActions();
           activateItemsInWishlist();
        
        if(SPR) {
          SPR.registerCallbacks();
          SPR.initRatingHandler();
          SPR.initDomEls();
          SPR.loadProducts();
          SPR.loadBadges();
          }
        
//          $('.wishlist-loader').fadeOut(500, function () {
//           $('.wishlist-grid').addClass('is_visible');
//           $('.wishlist-hero').addClass('is_visible');
//           if (numProductTiles == 0) {
//             $('.wishlist-grid--empty-list').addClass('is_visible');
//           } else {
//             $('.wishlist-grid--empty-list').hide();
//           }
//         });
      });
      } else {
        $('.wishlist-grid--empty-list').addClass('is_visible');
         $('.wishlist-grid--empty-list').show();
        
         $('.wishlist-loader').hide();
      }
    }
  };

  

  Wishlist.init = function () {
    if (window.location.href.indexOf('pages/wishlist') == -1) {
    	bindUIActions();
    }
    activateItemsInWishlist();
    loadWishlist();
  };

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
